import { gql, TypedDocumentNode } from "@apollo/client";

import { ManagedEntitiesGroupedByProvidersConnection, PageInfo, Stack } from "types/generated";

const SEARCH_MANAGED_ENTITIES_GROUP_BY_PROVIDERS_FRAGMENT = gql`
  fragment SearchManagedEntitiesGroupByProvidersFragment on SearchManagedEntitiesGroupedByProvidersOutput {
    edges {
      cursor
      node {
        id
        count
        drifted
        updatedAt
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
    }
  }
`;

type SearchManagedEntitiesGroupByProvidersData = {
  searchManagedEntitiesGroupByProviders: {
    edges: Array<ManagedEntitiesGroupedByProvidersConnection>;
    pageInfo: Pick<PageInfo, "endCursor" | "startCursor" | "hasNextPage">;
  };
};

export const SEARCH_MANAGED_ENTITIES_GROUP_BY_PROVIDERS: TypedDocumentNode<SearchManagedEntitiesGroupByProvidersData> = gql`
  query SearchManagedEntitiesGroupByProviders($input: SearchInput!) {
    searchManagedEntitiesGroupByProviders(input: $input) {
      ...SearchManagedEntitiesGroupByProvidersFragment
    }
  }
  ${SEARCH_MANAGED_ENTITIES_GROUP_BY_PROVIDERS_FRAGMENT}
`;

type SearchStackManagedEntitiesGroupByProvidersData = {
  stack: Pick<Stack, "id"> & SearchManagedEntitiesGroupByProvidersData;
};

export const SEARCH_STACK_MANAGED_ENTITIES_GROUP_BY_PROVIDERS: TypedDocumentNode<SearchStackManagedEntitiesGroupByProvidersData> = gql`
  query SearchStackManagedEntitiesGroupByProviders($stackId: ID!, $input: SearchInput!) {
    stack(id: $stackId) {
      id
      searchManagedEntitiesGroupByProviders(input: $input) {
        ...SearchManagedEntitiesGroupByProvidersFragment
      }
    }
  }
  ${SEARCH_MANAGED_ENTITIES_GROUP_BY_PROVIDERS_FRAGMENT}
`;
